import { styled } from '../../stitches/stitches.config'

export default styled('div', {
  safeAreaInset: 'bottom',
})
